import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';

export const maintenanceGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const url = state.url;

  // Erlaube /login und /admin/login immer
  if (url === '/login' || url.startsWith('/admin/login')) {
    return true;
  }

  // Erlaube /dashboard/* für eingeloggte Benutzer
  if (url.startsWith('/dashboard')) {
    return authService.isLoggedIn().pipe(
      take(1),
      map(user => {
        if (user) {
          return true;
        } else {
          // Wenn nicht eingeloggt, zu /maintenance weiterleiten
          router.navigate(['/maintenance']);
          return false;
        }
      })
    );
  }

  // Alle anderen Routen blockieren und zu /maintenance weiterleiten
  router.navigate(['/maintenance']);
  return false;
};
